export function Skeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div className="panel">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="skeleton" />
      ))}
    </div>
  );
}
